export class UserSettings {
  UserId: number;
  DefaultStartPage: string;
  DefaultTableView: string;
  Language: string;
  MSWindowPosition: string;
  IndividualPlanningMilestonesJson: any;
}
